import { ApiRoute } from '../../../constants/apiRoutes/apiRoute.ts';
import { PaginationQueryParams } from '../../../constants/apiRoutes/paginationQueryParams.ts';
import { useQuery } from '@tanstack/react-query';
import { baseQueryKeys, PagingListReturnModel } from '@cksoftware/react-base';

const fetchItems = async <T>(
  route: ApiRoute<PaginationQueryParams>,
  params: PaginationQueryParams
): Promise<PagingListReturnModel<T>> => {
  const axiosInstance = window.getAxios();
  const url = route.build(params);
  const response = await axiosInstance.get<PagingListReturnModel<T>>(url);
  return response.data;
};

export function useGenericCrudListQuery<T>(
  route: ApiRoute<PaginationQueryParams>,
  queryParameters: PaginationQueryParams
) {
  return useQuery({
    queryKey: [...baseQueryKeys.genericCrudList(route.path), { ...queryParameters }],
    queryFn: async () => fetchItems<T>(route, { ...queryParameters })
  });
}
